module.exports = __webpack_public_path__ + "92bba83549cfc34e7fec5ea4bec1f14a.png";